import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import BottomSheet from "@/components/BottomSheet";
import { formatNominalInput, parseNominal } from "@/lib/format";

export default function TabunganForm({ open, onClose, onSaved, existing = null }) {
  const [nama, setNama] = useState(existing?.nama || "");
  const [target, setTarget] = useState(
    existing?.target ? formatNominalInput(existing.target) : ""
  );
  const [deadline, setDeadline] = useState(existing?.deadline || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setNama(existing?.nama || "");
      setTarget(existing?.target ? formatNominalInput(existing.target) : "");
      setDeadline(existing?.deadline || "");
    }
  }, [open, existing]);

  const submit = async (e) => {
    e.preventDefault();
    const n = parseNominal(target);
    if (!nama.trim()) return toast.error("Nama goal wajib diisi");
    if (n <= 0) return toast.error("Target harus > 0");

    setBusy(true);
    try {
      const payload = {
        nama: nama.trim(),
        target: n,
        deadline: deadline || null,
      };
      if (existing) {
        await api.put(`/tabungan/${existing.id}`, payload);
        toast.success("Goal diperbarui");
      } else {
        await api.post("/tabungan", payload);
        toast.success("Goal tabungan dibuat");
      }
      onClose();
      onSaved && onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title={existing ? "Edit Goal Tabungan" : "Tambah Goal Tabungan"}
      testId="tabungan-form-sheet"
    >
      <form onSubmit={submit} className="space-y-4" data-testid="tabungan-form">
        <Field label="Nama goal">
          <input
            type="text"
            value={nama}
            onChange={(e) => setNama(e.target.value)}
            data-testid="tabungan-input-nama"
            className={inputCls}
            placeholder="mis. Nadzar 50 Juta"
            required
          />
        </Field>
        <Field label="Target (Rp)">
          <input
            type="text"
            inputMode="numeric"
            value={target}
            onChange={(e) => setTarget(formatNominalInput(e.target.value))}
            data-testid="tabungan-input-target"
            className={inputCls}
            required
          />
        </Field>
        <Field label="Deadline (opsional)">
          <input
            type="date"
            value={deadline}
            onChange={(e) => setDeadline(e.target.value)}
            data-testid="tabungan-input-deadline"
            className={inputCls}
          />
        </Field>
        <button
          type="submit"
          disabled={busy}
          data-testid="tabungan-submit"
          className="w-full h-11 rounded-xl font-semibold text-sm text-white tap disabled:opacity-60"
          style={{ backgroundColor: "#1F4E5F" }}
        >
          {busy ? "Menyimpan..." : "Simpan"}
        </button>
      </form>
    </BottomSheet>
  );
}

const inputCls =
  "mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-[#1F4E5F] focus:outline-none text-sm bg-white";

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-slate-600">{label}</span>
      {children}
    </label>
  );
}
